import { createContext, useContext, useState } from 'react';

const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [decisionObject, setDecisionObject] = useState({});
  const [strategyObject, setStrategyObject] = useState({});
  const [updateObject, setUpdateObject] = useState({});

  const [loading, setLoading] = useState(false);
  const startLoading = () => setLoading(true);
  const stopLoading = () => setLoading(false);

  return (
    <MyContext.Provider
      value={{
        decisionObject, setDecisionObject,
        strategyObject, setStrategyObject,
        updateObject, setUpdateObject,
        loading, startLoading, stopLoading,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => useContext(MyContext);
